module.exports = __webpack_public_path__ + "media/images/icons/outlined/flag-f2f8a0f2244c1518966542ba4a470c29.svg";